<template>
	<v-container fluid>
		<v-row class="mb-3 d-flex justify-space-between">
			<v-col cols="7" md="6" class="d-flex align-center">
				<div class="d-flex align-center">
					<v-icon class="me-5" style="color: #ff7e87">mdi-account-circle</v-icon>
					<p class="text-lg-h5 font-weight-600">{{ $t('agent-waiting-list') }}</p>
				</div>
			</v-col>

			<v-col class="d-flex align-center justify-end" cols="5">
				<v-text-field variant="plain" density="compact" hide-details class="box-shadow isRounded pb-2 pl-2"
					:placeholder="$t('search_by_agent_name')" v-model="searchQuery" @keyup.enter="searchAgent" style="
						border: 1px solid rgba(181, 183, 192, 1);
						background-color: rgba(255, 255, 255, 1);
						border-radius: 16px;
						padding: 8px, 16px, 8px, 16px;
					" @input="handleInput">
					<template v-slot:prepend>
						<div>
							<v-icon style="color: rgba(0, 0, 0, 1); font-size: 30px" class="ml-2"
								@click="searchAgent">mdi-magnify</v-icon>
						</div>
					</template>
				</v-text-field>
				<v-menu location="bottom" :close-on-content-click="false" v-model="notification">
					<template #activator="{ props }">
						<v-btn v-bind="props" class="text-capitalize isRounded elevation-0 mx-2 font-weight-bold"
							style="border: 1px solid rgba(181, 183, 192, 1)" height="51px">
							<template v-if="getNotification() > 0">
								<v-badge :content="getNotification()" color="#FF7E87">
									<v-icon icon="mdi-bell" size="large"></v-icon>
								</v-badge>
							</template>
							<template v-else>
								<v-icon icon="mdi-bell" size="large"></v-icon>
							</template>
						</v-btn>
					</template>

					<v-card min-width="450" max-height="70vh" class="mt-3 rounded-xl">
						<v-list>
							<v-list-item>Notification</v-list-item>
						</v-list>
						<v-divider></v-divider>
						<v-list v-if="notificationData.length > 0">
							<v-list-item v-for="(notification, index) in notificationData" :key="notification.id">
								<v-card>
									<v-card-text>
										<div>
											<div class="text-subtitle-2 ">
												{{ formatDate(notification.createdAt) }}
											</div>
										</div>
										<div class="my-2 font-weight-medium text-subtitle-2 " style="color:#FF7E87">
											{{ notification.title }}
										</div>
										<div>
											<v-row>
												<v-col cols='5'>
													<v-avatar color="grey" size="75" class="ml-5"
														:image="notification?.agentNotifications?.pictureUrl">
													</v-avatar>
												</v-col>
												<v-col>
													<div class="text-subtitle-2">
														<div>Name: {{ notification.agentNotifications?.firstName }} {{
															notification.agentNotifications?.lastName }} </div>
														<div>Contact: {{ notification.agentNotifications?.phone }}</div>
														<div>Email: {{ notification.agentNotifications?.email }}</div>
														<div>Type: {{
															notification.agentNotifications?.UserRoles[0].UserRole.type
																=== 'esg' ?
																'ESG' : 'IT-service'
														}}</div>
														<div class="text-blue text-subtitle-2 text-decoration-underline cursor-pointer"
															@click="openEditAgentDialog(notification.agentId, notification.id)">
															See profile
														</div>
													</div>
												</v-col>
											</v-row>
										</div>
									</v-card-text>
									<v-divider></v-divider>
								</v-card>
							</v-list-item>
						</v-list>

						<div v-else
							style="min-height:200px; align-items: center; display: flex; justify-content: center;">
							<div>No notifications</div>
						</div>
					</v-card>
				</v-menu>
			</v-col>
		</v-row>

		<v-card v-if="isFetchingAgents" height="400px" class="d-flex" align="center">
			<v-card-text class="text-center my-auto">
				<v-progress-circular color="grey" :size="80" indeterminate class="mb-4 mx-auto" />
				<div>Generating Report...</div>
			</v-card-text>
		</v-card>

		<v-card v-show="isFetchingAgents === false">
			<v-card-text>
				<div class="dashboard">
					<data-table :headers="isSmallScreen ? smallScreenHeaders : headers" :items="items"
						@openAgentEditor="openEditAgentDialog" @rejectAgent="handleRejectAgent"
						@approveAgent="handleApproveAgent" @reapprove-agent="handleReapproveAgent"
						@totalRowsPerPage="filterRowsPerPage" @pageNumber="changePage" />
				</div>
			</v-card-text>
		</v-card>
		<v-dialog v-model="showWaitingAgentProfile" width="auto">
			<edit-user @closeDialog="showWaitingAgentProfile = false" :agentDetails="agentDetials"
				@emit-update-agent-profile="updateAgent" @rejectAgent="handleRejectAgent"
				@approveAgent="handleApproveAgent" @reapprove-agent="handleReapproveAgent"></edit-user>
		</v-dialog>
		<v-dialog v-model="agentApproval" width="auto">
			<v-card min-width="350px">
				<v-title>
					<div class=" ma-4 d-flex justify-center">
						{{ $t('approve_this_agent') }} ?
					</div>
				</v-title>
				<div class="user_container mx-auto my-10">
					<v-avatar size="80" class="mx-5">
						<v-img src="@/assets/User.png"></v-img>
					</v-avatar>
					<div class="my-4">
						<div class="name">
							{{
								`${agentDetials.firstName} ${agentDetials.lastName}`
							}}
						</div>
						<div class="designation">
							{{ agentDetials.designation }}
						</div>
					</div>
				</div>
				<div class="bg-black d-flex justify-space-between pa-2">
					<div>
						<v-btn class="ms-auto" elevation="0" variant="text" @click="closeApproveAgentDialog">{{
							$t('cancel')
						}}</v-btn>
					</div>
					<div>
						<v-btn class="ms-auto text-green-lighten-1" elevation="0" variant="text"
							@click="approveAgent(agentId)">{{ $t('confirm') }}</v-btn>
					</div>
				</div>
			</v-card>
		</v-dialog>
		<v-dialog v-model="agentReject" width="auto">
			<v-card max-width="auto">
				<v-card-title>
					{{ $t('reject_this_agent') }} ?
				</v-card-title>
				<div class="user_container mx-auto my-10">
					<v-avatar size="80" class="mx-5">
						<v-img src="@/assets/User.png"></v-img>
					</v-avatar>
					<div class="my-4">
						<div class="name">
							{{
								`${agentDetials.firstName} ${agentDetials.lastName}`
							}}
						</div>
						<div class="designation">
							{{ agentDetials.designation }}
						</div>
					</div>
				</div>
				<div class="mx-5">
					<h4>{{ $t('reason') }}</h4>
					<v-textarea :placeholder="$t('reason')" variant="outlined" v-model="agentRejectReason"></v-textarea>
				</div>
				<div class="bg-black d-flex justify-space-between pa-2">
					<div>
						<v-btn class="ms-auto" elevation="0" variant="text" @click="agentReject = false">{{ $t('cancel')
						}}</v-btn>
					</div>
					<div>
						<v-btn class="ms-auto text-red-lighten-1" elevation="0" variant="text"
							@click="closeRejectAgentDialog">{{ $t('confirm') }}</v-btn>
					</div>
				</div>
			</v-card>
		</v-dialog>
		<v-dialog v-model="agentStatus" width="auto">
			<v-card max-width="500">
				<v-card-text>
					<span class="text-green-darken-1 text-bold">{{
						`${agentDetials.firstName} ${agentDetials.lastName} `
					}}</span>has been approved.
				</v-card-text>
			</v-card>
		</v-dialog>
		<v-dialog v-model="reapproveAgent" width="auto">
			<v-card min-width="350px">
				<v-title>
					<div class="ma-3 d-flex justify-center">
						{{ $t('reapprove-this-agent') }} ?
					</div>
				</v-title>
				<div class="user_container mx-auto my-10">
					<v-avatar size="80" class="mx-5">
						<v-img src="@/assets/User.png"></v-img>
					</v-avatar>
					<div class="my-4">
						<div class="name">
							{{
								`${agentDetials.firstName} ${agentDetials.lastName}`
							}}
						</div>
						<div class="designation">
							{{ agentDetials.designation }}
						</div>
					</div>
				</div>
				<div class="mx-5">
					<h4>{{ $t('reason') }}</h4>
					<v-textarea :placeholder="$t('reason')" variant="outlined"
						v-model="agentReApprovalReason"></v-textarea>
				</div>
				<div class="bg-black d-flex justify-space-between pa-2">
					<div>
						<v-btn class="ms-auto" elevation="0" variant="text"
							@click="closeReapproveDialog" >{{ $t('cancel') }}</v-btn>
					</div>
					<div>
						<v-btn class="ms-auto text-green-lighten-1 font-weight-bold" elevation="0" variant="text"
							@click="reApproveAgent(agentId)">{{ $t('confirm') }}</v-btn>
					</div>
				</div>
			</v-card>
		</v-dialog>
		<v-snackbar v-model="snackbar" :timeout="5000" rounded="pill" color="#8EEDB3" width="500px">
			<div class="d-flex mx-2">
				<v-icon>mdi-check</v-icon>
				<p class="mx-2">Agent has been approved .</p>
			</div>
			<template v-slot:actions>
				<div class="mx-2">
					<v-icon color="black" @click="snackbar = false">
						mdi-close
					</v-icon>
				</div>
			</template>
		</v-snackbar>
	</v-container>
</template>

<script>
import PendingAgentDataTable from '@/components/PendingAgentDataTable.vue'
import agentService from '@/services/API/agentService'
import EditWaitngAgentProfile from '@/components/EditWaitngAgentProfile.vue'
import notification from '@/services/API/notification'
import searchList from '@/services/API/searchList'
import settings from '@/services/API/settings'
import moment from 'moment'

export default {
	components: {
		'data-table': PendingAgentDataTable,
		'edit-user': EditWaitngAgentProfile,
	},
	data: () => ({
		agentReApprovalReason: '',
		notificationData: null,
		notification: false,
		reapproveAgent: false,
		agentId: null,
		agentRejectReason: '',
		showIncidenceResponse: null,
		items: [],
		isFetchingAgents: false,
		showingId: null,
		agentStatus: false,
		agentApproval: false,
		snackbar: false,
		agentReject: false,
		showWaitingAgentProfile: false,
		agentDetials: {},
		headers: [
			{
				text: 'Date & Time',
				value: 'updatedAt',
				sortable: true,
				width: '5%',
			},
			{
				text: 'Agent name',
				value: 'agentDetial',
				sortable: true,
				width: '30%',
			},
			{
				text: 'Email',
				value: 'email',
				sortable: true,
				width: '25%',
			},
			{
				text: 'Contact',
				value: 'phone',
				sortable: true,
				width: '25%',
			},
			{
				text: 'Type',
				value: 'type',
			},
			{
				text: '',
				value: 'buttons',
				width: '25%',
			},
		],
		searchQuery: '',
	}),
	async created() {
		this.fetchAgentList()
		await notification.getNotifications().then((response) => {
			if (response.status === 200) {
				this.$store.state.notifications = response.data.notifications
			}
		})
		const queryObj = {
			type: "user",
			userId: localStorage.getItem('userId')
		}

		await notification.listNotifications(queryObj.type, queryObj.userId).then((response) => {

			if (response.status === 200) {

				this.notificationData = response.data.data.notifications
			}
		})

	},
	computed: {
		isSmallScreen() {
			return this.$vuetify.display.smAndDown
		},
		smallScreenHeaders() {
			return this.headers.filter((item) =>
				['Agent name', 'Skills', ''].includes(item.text)
			)
		},
	},
	emits: ['openAgentEditor'],
	methods: {
		formatDate(date) {
			return moment(date).format('MM/DD/YYYY,HH:mm')
		},
		getNotification() {
			try {

				return this.$store.state.notifications[1].count

			} catch (err) {
				return 0
			}
		},
		async updateAgent(obj) {
			// Convert all skills to lowercase using map
			obj.skills = obj.skills.map((skill) => skill.toLowerCase())

			// Remove duplicates using Set and convert back to an array
			obj.skills = Array.from(new Set(obj.skills))

			await agentService
				.updateWaitingAgentProfile(
					obj.id,
					obj /** send the payload */,
					obj.pictureUrl
				)
				.then(() => {
					this.fetchAgentList()
					window.location.reload();
				})
				.catch((err) => {
					console.log(err)
				})
		},
		async changePage(data) {
			this.fetchAgentList(data)
		},
		async filterRowsPerPage(data) {
			await settings
				.updatePageSettings(localStorage.getItem('userId'), {
					tableRowsPerPage: data,
				})
				.then(() => {
					this.fetchAgentList()
				})
				.catch(() => {
					this.isFetchingIncidents = true
				})
		},
		async getAgentDetials(id) {
			await agentService.getSingleAgent(id).then((response) => {
				this.agentDetials = response.data
			})
		},
		async openEditAgentDialog(id, notificationId) {
			await this.getAgentDetials(id)
			this.markNotificationAsRead(notificationId)
			this.showWaitingAgentProfile = true
		},
		async markNotificationAsRead(notificationId) {
			try {
				const response = await notification.markAsRead(notificationId);
				if (response.status !== 200) {
					console.error("Failed to mark notification as read");
				}
			} catch (error) {
				console.error("Error marking notification as read", error);
			}
		},
		async approveAgent(id) {
			await agentService.approveAgent(id).then(() => {
				this.agentApproval = false
				this.fetchAgentList()
				// this.agentStatus = true
				this.snackbar = true
				this.showWaitingAgentProfile = false
			})
		},
		async reApproveAgent(id) {
			await agentService
				.reApproveAgent(id, this.agentReApprovalReason)
				.then(() => {
					this.reapproveAgent = false
					this.fetchAgentList()
					this.snackbar = true
					// this.agentStatus = true
				})
		},
		closeReapproveDialog() {
			this.reapproveAgent = false
		},
		closeApproveAgentDialog() {
			this.agentApproval = false
		},
		async closeRejectAgentDialog() {
			await agentService
				.declineAgent(this.agentId, this.agentRejectReason)
				.then(() => {
					this.fetchAgentList()
					this.showWaitingAgentProfile = false
					this.agentReject = false
				})
		},
		handleReapproveAgent(id) {
			this.reapproveAgent = true
			this.agentId = id
			this.getAgentDetials(id)
		},

		handleApproveAgent(id) {
			this.agentApproval = true
			this.agentId = id
			this.getAgentDetials(id)
		},

		handleRejectAgent(id) {
			this.agentReject = true
			this.agentId = id
			this.getAgentDetials(id)
		},

		async fetchAgentList(pageNumber) {
			this.isFetchingAgents = true
			await agentService
				.getAllPendingAgents(pageNumber)

				.then((response) => {

					this.items = response.data.data
					this.isFetchingAgents = false
				})
				.catch(() => {
					this.isFetchingAgents = false
				})
		},
		async searchAgent() {
			this.isFetchingAgents = true
			if (this.searchQuery) {
				await searchList
					.SearchPendingAgents(this.searchQuery)
					.then((response) => {
						this.items = response.data.data
						this.isFetchingAgents = false
					})
					.catch((err) => {
						console.error(err)
						this.isFetchingAgents = false
					})
			} else {
				this.fetchAgentList()
			}
		},
		handleInput() {
			if (!this.searchQuery) {
				this.fetchAgentList()
			}
		},
	},
}
</script>

<style scoped>
.user_container {
	display: flex;
}

.box-shadow {
	box-shadow: 0px 0px 16px 0px rgba(131, 133, 143, 0.1) !important;
}

.v-card::-webkit-scrollbar {
	display: none;
}

/* Hide scrollbar for Firefox */
.v-card {
	scrollbar-width: none;
}

/* Hide scrollbar for Edge and IE */
.v-card {
	-ms-overflow-style: none;
}
</style>
